import type { SchoolId } from '@suntex.fim/api-client';
import { EntityLevel } from '@suntex.fim/enums';
import { SchoolProvider } from '@suntex.fim/school';

import {
  type EntityLayoutProps,
  createEntityLayout,
} from './createEntityLayout';

export type SchoolLayoutProps = EntityLayoutProps;

/** Layout wrapper for school-scoped routes (`/school/:schoolId/...`). */
export const SchoolLayout = createEntityLayout<SchoolId>({
  entityLevel: EntityLevel.School,
  paramName: 'schoolId',
  renderProvider: (id, children) => (
    <SchoolProvider schoolId={id}>{children}</SchoolProvider>
  ),
});
